import { AfterViewInit, Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
  selector: 'nz-select[appUppercaseSelect]'
})
export class UppercaseSelectDirective implements AfterViewInit {
    
  constructor(private el: ElementRef) {}

   ngAfterViewInit() {
      this.capitalize();
   }

   private capitalize() {
    const searchInput = this.el.nativeElement.querySelector('input');
    if (searchInput) {
      searchInput.style.textTransform = 'uppercase';
      searchInput.addEventListener('input', this.onInputChange.bind(this));
    }
   }

   private onInputChange(event: Event) {
     const input = event.target as HTMLInputElement;
      const value = input.value.toUpperCase();
      input.value = value;
   }
}